// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"fd2f8295","364":"fd2f8295","435":"fd2f8295","483":"66dc2dd8","515":"fd2f8295","591":"44580e4d","664":"66dc2dd8"}[chunkId] + ".chunk.css";
};